import React from 'react'

import './style.scss'
import { useCommonStyles } from 'styles/globalStyles'

interface Props {
  value?: string | number
  handleChange?: any
  label: string
  type?: string
  autocompletetype?: string
  limit?: number
  className?: string
  inputClassName?: string
  error?: string
  name?: string
}

const GeneralInput = (props: Props) => {
  const classes = useCommonStyles(props)

  return (
    <div className={`label-float ${props.className} ${!!props.error ? classes.errorInputStyle : ''}`}>
      <input
        type={props.type}
        placeholder=' '
        onChange={props.handleChange}
        maxLength={props.limit}
        autoComplete={props.autocompletetype}
        value={props.value}
        className={props.inputClassName}
        name={props.name}
      />
      <label>{props.label}</label>
      {!!props.error && <span className={classes.errorInputText}>{props.error}</span>}
    </div>
  )
}

export default GeneralInput
